// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__EcSPK","link":"footer_link__D6Y3Y","subtitle":"footer_subtitle__lFbiv"};